import { SwitchInput } from 'components/HookForm/Input/Switch/Switch';
import { EntityName } from 'modules/api/locHub/entity/name/name';
import React, { ReactElement } from 'react';
import { UseFormMethods } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { AutomationRecursiveCrawlInputI18n } from './I18n';

interface Props {
  control: UseFormMethods['control'];
  value?: boolean;
}

export const AutomationRecursiveCrawl: React.FC<Props> = ({ value, control }): ReactElement => {
  const [t] = useTranslation();
  const namespace = AutomationRecursiveCrawlInputI18n.configuration.namespace;
  const label = t(`${namespace}.label`);
  return (
    <SwitchInput
      id={`${EntityName.AUTOMATION}-recursive-crawl`}
      name={`${EntityName.AUTOMATION}RecursiveCrawl`}
      label={label}
      control={control}
    />
  );
};
